var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ax-result-page"},[_c('div',{staticClass:"result-box"},[_c('img',{staticClass:"bigImg",attrs:{"src":_vm.imgSrc,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text))]),_c('p',{staticClass:"gray"},[_vm._v(_vm._s(_vm.subtext))])])])}
var staticRenderFns = []

export { render, staticRenderFns }